<mat-form-field #formFieldContainer floatLabel="always" class="drop-down-open-class" >
     <mat-label
      #labelContainer  (click)="toggleTooltip(tooltip)"
      class="{{componentDefinition?.mandatory ? 'mandatory' : ''}}">
      {{componentDefinition?.label}}
    </mat-label>
    <div class="labelToolTipContainer"
         #tooltip="matTooltip"
         matTooltip="{{componentDefinition.label}}"
         [matTooltipDisabled]="showToolTip(tooltip,formFieldContainer,labelContainer)">
    </div>
    <input matInput hidden />
    <ng-select #ddOpen
        [items]="selectedOptions"
        placeholder="Select or enter value"
        [formControl]="formControl"
        (keyup)="keyPressUp($event)"
        (paste)="onPaste($event)"
        (blur)="onBlur($event)"
        (keydown)="keyDown($event)"
        (change) ="ddOpen.blur()"
        [clearable]=false
        >
        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
            <span *ngIf="item" title="{{item}}">{{ item }}</span>
            <span class="drop-down-open-remove-option" (click)="removeHandler($event, item)" [hidden]="(componentDefinition.dropDownList.indexOf(item) !== -1)">×</span>
        </ng-template>
        <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
             <span *ngIf="item" title="{{item}}">{{ item }}</span>
        </ng-template>
    </ng-select>
    <ft-validation-display [model]="document" [componentDefinition]="componentDefinition"></ft-validation-display>
</mat-form-field>
